// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__nhGd7","buttons":"SendReceipts_buttons__3-xMA","email":"SendReceipts_email__1E7_B","bookApptTitle":"SendReceipts_bookApptTitle__1ih10"};